module.exports = __webpack_public_path__ + "static/media/f.44e8606e.svg";